import React from "react";
import Typography from "@mui/material/Typography";
import Choices from "../../Choices";
import ReusableAccordian from "../../ReusableAccordion";
import { Image } from "cloudinary-react";
import { screenColors } from "./defaults";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useSliderScreenSelector from "./useSliderScreenSelector";

const ColLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
}));

const ColLayoutLeftDivider = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

export default function SlidingScreenAccordian() {
  const {
    handleClick,
    slidingScreenImgShown,
    screenColorChoice,
    optionsDisplayed,
  } = useSliderScreenSelector();

  return (
    <ReusableAccordian
      accordionName="screen"
      heading="Sliding Screen"
      secondaryHeading="Select Screen Option"
      colOrRow="col"
    >
      <RowLayout>
        <ColLayoutSpacing>
          <Typography variant="subtitle1">
            Screen Layout
            <span style={{ color: "red", fontSize: 20 }}>*</span>
          </Typography>
          <RowLayout>
            {optionsDisplayed.map((state) => (
              <div key={state.id}>
                <Choices
                  label={state.label}
                  variant="filled"
                  checkMark={true}
                  disabled={true}
                />
              </div>
            ))}
          </RowLayout>
        </ColLayoutSpacing>

        <ColLayoutLeftDivider>
          <Typography variant="subtitle1">
            Select an Extrusion Color{" "}
            <span style={{ color: "red", fontSize: 20 }}>*</span>
          </Typography>
          <RowLayout>
            {screenColors.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={
                    state.label === screenColorChoice ? "filled" : "outlined"
                  }
                  checkMark={state.label === screenColorChoice}
                />
              </div>
            ))}
          </RowLayout>
        </ColLayoutLeftDivider>
      </RowLayout>

      {slidingScreenImgShown && (
        <ColLayout>
          <Image
            secure="true"
            cloudName="ag-millworks"
            publicId={slidingScreenImgShown}
          />
          <Typography variant="caption">*As Viewed from Exterior</Typography>
        </ColLayout>
      )}
    </ReusableAccordian>
  );
}
